import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from '../../utils/api';
import AdminLayout from '../../components/AdminLayout';
import {
  FaEdit, FaTrash, FaPlus, FaTimes, FaSearch, FaSave,
  FaChevronRight, FaChevronDown, FaFolderOpen, FaFolder,
  // All available icons for the picker
  FaRobot, FaServer, FaCode, FaShieldAlt, FaGlobe, FaBullhorn,
  FaChartBar, FaChartLine, FaShareAlt, FaShoppingCart, FaMoneyBillWave,
  FaCreditCard, FaMobileAlt, FaGamepad, FaUserSecret, FaLink, FaBlog,
  FaComments, FaTools, FaStar, FaHandshake, FaDatabase, FaEnvelopeOpenText,
  FaLock, FaImage, FaRocket, FaNetworkWired, FaDesktop, FaPuzzlePiece,
  FaGift, FaFileAlt, FaEye, FaWifi, FaMapMarkerAlt, FaWordpress,
  FaThLarge, FaHome, FaEnvelope, FaInfoCircle, FaHeart, FaCloud,
  FaMusic, FaVideo, FaCamera, FaBookOpen, FaPen, FaPalette,
  FaCog, FaBolt, FaFire, FaLeaf, FaAnchor, FaBell, FaBriefcase,
  FaBug, FaBuilding, FaBus, FaCalculator, FaCalendar, FaCar,
  FaChess, FaClipboard, FaClock, FaCompactDisc, FaCrown,
  FaCube, FaCut, FaDna, FaDollarSign, FaDove, FaDrum,
  FaFeather, FaFilm, FaFingerprint, FaFlag, FaFlask, FaFootballBall,
  FaGem, FaGraduationCap, FaGuitar, FaHammer, FaHeadphones,
  FaHeartbeat, FaHiking, FaHistory, FaHorse, FaHospital,
  FaHotdog, FaIceCream, FaInfinity, FaKey, FaLanguage,
  FaLaptop, FaLightbulb, FaMagic, FaMap, FaMedal, FaMicrophone,
  FaMountain, FaNewspaper, FaPaintBrush, FaPaperPlane, FaPhone,
  FaPiggyBank, FaPlane, FaPray, FaPrint, FaRadiation,
  FaRecycle, FaSatellite, FaSeedling, FaShip, FaSkull,
  FaSnowflake, FaSpaceShuttle, FaSpider, FaStethoscope, FaStore,
  FaSun, FaSwimmer, FaTablet, FaTruck, FaUmbrella,
  FaUniversity, FaUserTie, FaWallet, FaWrench
} from 'react-icons/fa';

// Icon registry: name → component + tags for search
const ICON_REGISTRY = [
  { name: 'FaRobot', icon: FaRobot, tags: 'ai robot automation bot machine' },
  { name: 'FaServer', icon: FaServer, tags: 'server hosting vps cloud' },
  { name: 'FaCode', icon: FaCode, tags: 'code development programming software' },
  { name: 'FaShieldAlt', icon: FaShieldAlt, tags: 'security shield adult protection' },
  { name: 'FaGlobe', icon: FaGlobe, tags: 'globe world domain website internet' },
  { name: 'FaBullhorn', icon: FaBullhorn, tags: 'marketing advertising announce promotion' },
  { name: 'FaChartBar', icon: FaChartBar, tags: 'analytics chart traffic stats' },
  { name: 'FaChartLine', icon: FaChartLine, tags: 'chart growth sem ppc trend' },
  { name: 'FaShareAlt', icon: FaShareAlt, tags: 'social share network media' },
  { name: 'FaShoppingCart', icon: FaShoppingCart, tags: 'shop ecommerce cart buy store' },
  { name: 'FaMoneyBillWave', icon: FaMoneyBillWave, tags: 'money monetize revenue income' },
  { name: 'FaCreditCard', icon: FaCreditCard, tags: 'payment credit card pay checkout' },
  { name: 'FaMobileAlt', icon: FaMobileAlt, tags: 'mobile phone app mvas' },
  { name: 'FaGamepad', icon: FaGamepad, tags: 'game gaming play controller' },
  { name: 'FaUserSecret', icon: FaUserSecret, tags: 'proxy spy detective browser privacy' },
  { name: 'FaLink', icon: FaLink, tags: 'link url chain connect' },
  { name: 'FaBlog', icon: FaBlog, tags: 'blog writing content article' },
  { name: 'FaComments', icon: FaComments, tags: 'chat comments forum discussion' },
  { name: 'FaTools', icon: FaTools, tags: 'tools utility wrench settings' },
  { name: 'FaStar', icon: FaStar, tags: 'star favorite popular featured' },
  { name: 'FaHandshake', icon: FaHandshake, tags: 'affiliate partner alliance deal' },
  { name: 'FaDatabase', icon: FaDatabase, tags: 'database data backend storage' },
  { name: 'FaEnvelopeOpenText', icon: FaEnvelopeOpenText, tags: 'email newsletter mail message' },
  { name: 'FaLock', icon: FaLock, tags: 'lock security paywall unlock' },
  { name: 'FaImage', icon: FaImage, tags: 'image photo picture media creative' },
  { name: 'FaRocket', icon: FaRocket, tags: 'rocket launch startup fast speed' },
  { name: 'FaNetworkWired', icon: FaNetworkWired, tags: 'network cdn infrastructure wire' },
  { name: 'FaDesktop', icon: FaDesktop, tags: 'desktop computer monitor screen pop' },
  { name: 'FaPuzzlePiece', icon: FaPuzzlePiece, tags: 'puzzle plugin extension addon' },
  { name: 'FaGift', icon: FaGift, tags: 'gift lottery prize reward' },
  { name: 'FaFileAlt', icon: FaFileAlt, tags: 'file document landing page' },
  { name: 'FaEye', icon: FaEye, tags: 'eye view spy watch monitor' },
  { name: 'FaWifi', icon: FaWifi, tags: 'wifi push notification signal' },
  { name: 'FaMapMarkerAlt', icon: FaMapMarkerAlt, tags: 'location map tracking marker geo' },
  { name: 'FaWordpress', icon: FaWordpress, tags: 'wordpress cms blog website' },
  { name: 'FaThLarge', icon: FaThLarge, tags: 'grid category general layout' },
  { name: 'FaHome', icon: FaHome, tags: 'home house main dashboard' },
  { name: 'FaEnvelope', icon: FaEnvelope, tags: 'email envelope mail contact' },
  { name: 'FaInfoCircle', icon: FaInfoCircle, tags: 'info about help information' },
  { name: 'FaSearch', icon: FaSearch, tags: 'search find seo lookup' },
  { name: 'FaHeart', icon: FaHeart, tags: 'heart love favorite health' },
  { name: 'FaCloud', icon: FaCloud, tags: 'cloud hosting storage saas' },
  { name: 'FaMusic', icon: FaMusic, tags: 'music audio sound media' },
  { name: 'FaVideo', icon: FaVideo, tags: 'video camera streaming film' },
  { name: 'FaCamera', icon: FaCamera, tags: 'camera photo photography' },
  { name: 'FaBookOpen', icon: FaBookOpen, tags: 'book education learn read study' },
  { name: 'FaPen', icon: FaPen, tags: 'pen write edit compose' },
  { name: 'FaPalette', icon: FaPalette, tags: 'palette design art creative color' },
  { name: 'FaCog', icon: FaCog, tags: 'settings gear configuration options' },
  { name: 'FaBolt', icon: FaBolt, tags: 'bolt lightning fast speed power' },
  { name: 'FaFire', icon: FaFire, tags: 'fire hot trending popular' },
  { name: 'FaLeaf', icon: FaLeaf, tags: 'leaf nature eco organic green' },
  { name: 'FaAnchor', icon: FaAnchor, tags: 'anchor marine stable' },
  { name: 'FaBell', icon: FaBell, tags: 'bell notification alert' },
  { name: 'FaBriefcase', icon: FaBriefcase, tags: 'briefcase business work job' },
  { name: 'FaBug', icon: FaBug, tags: 'bug debug error fix' },
  { name: 'FaBuilding', icon: FaBuilding, tags: 'building company office corporate' },
  { name: 'FaCalculator', icon: FaCalculator, tags: 'calculator math finance compute' },
  { name: 'FaCalendar', icon: FaCalendar, tags: 'calendar date schedule event' },
  { name: 'FaCrown', icon: FaCrown, tags: 'crown premium vip king' },
  { name: 'FaCube', icon: FaCube, tags: 'cube 3d block product' },
  { name: 'FaDollarSign', icon: FaDollarSign, tags: 'dollar money currency finance' },
  { name: 'FaDove', icon: FaDove, tags: 'dove peace bird' },
  { name: 'FaFeather', icon: FaFeather, tags: 'feather light write' },
  { name: 'FaFilm', icon: FaFilm, tags: 'film movie cinema video' },
  { name: 'FaFingerprint', icon: FaFingerprint, tags: 'fingerprint identity security unique' },
  { name: 'FaFlag', icon: FaFlag, tags: 'flag country report milestone' },
  { name: 'FaFlask', icon: FaFlask, tags: 'flask science lab experiment' },
  { name: 'FaGem', icon: FaGem, tags: 'gem diamond premium luxury' },
  { name: 'FaGraduationCap', icon: FaGraduationCap, tags: 'graduation education university school' },
  { name: 'FaHeadphones', icon: FaHeadphones, tags: 'headphones audio music support' },
  { name: 'FaHeartbeat', icon: FaHeartbeat, tags: 'heartbeat health medical pulse' },
  { name: 'FaKey', icon: FaKey, tags: 'key access password login' },
  { name: 'FaLanguage', icon: FaLanguage, tags: 'language translate multilingual' },
  { name: 'FaLaptop', icon: FaLaptop, tags: 'laptop computer work remote' },
  { name: 'FaLightbulb', icon: FaLightbulb, tags: 'lightbulb idea creative innovation' },
  { name: 'FaMagic', icon: FaMagic, tags: 'magic wand creative auto' },
  { name: 'FaMap', icon: FaMap, tags: 'map navigation location direction' },
  { name: 'FaMedal', icon: FaMedal, tags: 'medal award achievement badge' },
  { name: 'FaMicrophone', icon: FaMicrophone, tags: 'microphone podcast audio voice' },
  { name: 'FaMountain', icon: FaMountain, tags: 'mountain outdoor adventure nature' },
  { name: 'FaNewspaper', icon: FaNewspaper, tags: 'newspaper news article press media' },
  { name: 'FaPaintBrush', icon: FaPaintBrush, tags: 'paintbrush art design creative' },
  { name: 'FaPaperPlane', icon: FaPaperPlane, tags: 'send paper plane message telegram' },
  { name: 'FaPhone', icon: FaPhone, tags: 'phone call contact telephone' },
  { name: 'FaPiggyBank', icon: FaPiggyBank, tags: 'piggy bank save money finance' },
  { name: 'FaPlane', icon: FaPlane, tags: 'plane travel flight airplane' },
  { name: 'FaPrint', icon: FaPrint, tags: 'print printer document' },
  { name: 'FaRecycle', icon: FaRecycle, tags: 'recycle reuse green eco' },
  { name: 'FaSatellite', icon: FaSatellite, tags: 'satellite space signal broadcast' },
  { name: 'FaSeedling', icon: FaSeedling, tags: 'seedling growth plant organic' },
  { name: 'FaShip', icon: FaShip, tags: 'ship boat shipping delivery' },
  { name: 'FaSnowflake', icon: FaSnowflake, tags: 'snowflake cold freeze unique' },
  { name: 'FaSpaceShuttle', icon: FaSpaceShuttle, tags: 'space shuttle launch deploy' },
  { name: 'FaStore', icon: FaStore, tags: 'store shop marketplace retail' },
  { name: 'FaSun', icon: FaSun, tags: 'sun bright light day' },
  { name: 'FaTablet', icon: FaTablet, tags: 'tablet ipad mobile device' },
  { name: 'FaTruck', icon: FaTruck, tags: 'truck delivery shipping logistics' },
  { name: 'FaUmbrella', icon: FaUmbrella, tags: 'umbrella protection insurance' },
  { name: 'FaUniversity', icon: FaUniversity, tags: 'university bank institution' },
  { name: 'FaUserTie', icon: FaUserTie, tags: 'user business professional manager' },
  { name: 'FaWallet', icon: FaWallet, tags: 'wallet money payment crypto' },
  { name: 'FaWrench', icon: FaWrench, tags: 'wrench fix repair maintain' },
];

function getIconByName(name) {
  const entry = ICON_REGISTRY.find(i => i.name === name);
  return entry ? entry.icon : FaThLarge;
}

function IconPicker({ value, onChange, onClose }) {
  const [search, setSearch] = useState('');
  const searchInputRef = useRef(null);

  useEffect(() => { searchInputRef.current?.focus(); }, []);

  const filtered = useMemo(() => {
    if (!search) return ICON_REGISTRY;
    const q = search.toLowerCase();
    return ICON_REGISTRY.filter(i => i.name.toLowerCase().includes(q) || i.tags.includes(q));
  }, [search]);

  return (
    <div className="cat-icon-picker-overlay" onClick={onClose}>
      <div className="cat-icon-picker" onClick={e => e.stopPropagation()}>
        <div className="cat-icon-picker-header">
          <h3>Choose an Icon</h3>
          <button className="cat-icon-picker-close" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="cat-icon-picker-search">
          <FaSearch className="cat-icon-search-icon" />
          <input ref={searchInputRef} type="text" placeholder="Search icons... (e.g. robot, money, chart)" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div className="cat-icon-picker-grid">
          {filtered.map(item => {
            const Icon = item.icon;
            return (
              <button key={item.name} className={`cat-icon-picker-item ${value === item.name ? 'cat-icon-picker-selected' : ''}`} onClick={() => { onChange(item.name); onClose(); }} title={item.name.replace('Fa', '')}>
                <Icon /><span>{item.name.replace('Fa', '')}</span>
              </button>
            );
          })}
          {filtered.length === 0 && <div className="cat-icon-picker-empty">No icons found for "{search}"</div>}
        </div>
      </div>
    </div>
  );
}


function Categories() {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ name: '', icon: '', description: '', sort_order: 0, parent_id: '' });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [expanded, setExpanded] = useState(new Set());

  const fetchCategories = () => {
    api.get('/categories').then(res => {
      setCategories(res.data);
      // Auto-expand parents that have children
      const parentIds = new Set();
      res.data.forEach(c => { if (c.parent_id) parentIds.add(c.parent_id); });
      setExpanded(parentIds);
    });
  };

  useEffect(() => { fetchCategories(); }, []);

  const resetForm = () => {
    setForm({ name: '', icon: '', description: '', sort_order: 0, parent_id: '' });
    setEditingId(null);
    setShowForm(false);
    setError('');
  };

  const parentOptions = categories.filter(c => !c.parent_id && c.id !== editingId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      if (editingId) {
        await api.put(`/categories/${editingId}`, form);
        setSuccess('Category updated!');
      } else {
        await api.post('/categories', form);
        setSuccess('Category created!');
      }
      resetForm();
      fetchCategories();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Error saving category');
    }
    setLoading(false);
  };

  const handleEdit = (cat) => {
    setEditingId(cat.id);
    setForm({ name: cat.name, icon: cat.icon || '', description: cat.description || '', sort_order: cat.sort_order, parent_id: cat.parent_id || '' });
    setShowForm(true);
    setError('');
    setSuccess('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    const children = categories.filter(c => c.parent_id === id);
    const msg = children.length > 0
      ? `Delete this category and its ${children.length} subcategorie(s)? Resources will be uncategorized.`
      : 'Delete this category? Resources will be uncategorized.';
    if (!window.confirm(msg)) return;
    await api.delete(`/categories/${id}`);
    setSuccess('Category deleted.');
    fetchCategories();
    setTimeout(() => setSuccess(''), 3000);
  };

  const toggleExpand = (id) => {
    setExpanded(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const expandAll = () => {
    const parentIds = new Set();
    categories.forEach(c => { if (c.parent_id) parentIds.add(c.parent_id); });
    setExpanded(parentIds);
  };

  const collapseAll = () => setExpanded(new Set());

  const SelectedIcon = form.icon ? getIconByName(form.icon) : null;

  // Build tree
  const filteredCategories = searchQuery
    ? categories.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.slug.includes(searchQuery.toLowerCase()))
    : categories;

  const parents = filteredCategories.filter(c => !c.parent_id);
  const childrenMap = {};
  filteredCategories.filter(c => c.parent_id).forEach(c => {
    if (!childrenMap[c.parent_id]) childrenMap[c.parent_id] = [];
    childrenMap[c.parent_id].push(c);
  });
  // When searching, include parents of matched children
  if (searchQuery) {
    filteredCategories.filter(c => c.parent_id).forEach(c => {
      if (!parents.find(p => p.id === c.parent_id)) {
        const parent = categories.find(p => p.id === c.parent_id);
        if (parent) parents.push(parent);
      }
    });
  }

  const parentCount = categories.filter(c => !c.parent_id).length;
  const childCount = categories.filter(c => c.parent_id).length;
  const hasChildren = Object.keys(childrenMap).length > 0 || childCount > 0;

  return (
    <AdminLayout>
      {/* Header */}
      <div className="cat-page-header">
        <div>
          <h2 className="cat-page-title">Categories</h2>
          <p className="cat-page-subtitle">
            {parentCount} categories{childCount > 0 && <>, {childCount} subcategories</>}
          </p>
        </div>
        <button
          className="rf-btn rf-btn-save"
          onClick={() => { setShowForm(true); setEditingId(null); setForm({ name: '', icon: '', description: '', sort_order: 0, parent_id: '' }); }}
        >
          <FaPlus /> Add Category
        </button>
      </div>

      {/* Alerts */}
      {success && <div className="rf-alert rf-alert-success"><FaStar /> {success}</div>}
      {error && <div className="rf-alert rf-alert-error"><FaTimes /> {error}</div>}

      {/* Form Panel */}
      {showForm && (
        <div className="cat-form-panel">
          <div className="cat-form-header">
            <h3>{editingId ? 'Edit Category' : 'New Category'}</h3>
            <button className="cat-form-close" onClick={resetForm}><FaTimes /></button>
          </div>

          <form onSubmit={handleSubmit} className="cat-form">
            <div className="cat-form-layout">
              <div className="cat-icon-selector">
                <label className="rf-label">Icon</label>
                <button type="button" className="cat-icon-choose-btn" onClick={() => setShowIconPicker(true)}>
                  {SelectedIcon ? <div className="cat-icon-chosen"><SelectedIcon /></div> : <div className="cat-icon-empty"><FaPlus /></div>}
                  <span className="cat-icon-choose-text">{form.icon ? form.icon.replace('Fa', '') : 'Choose Icon'}</span>
                </button>
                {form.icon && (
                  <button type="button" className="cat-icon-clear" onClick={() => setForm({ ...form, icon: '' })}><FaTimes /> Clear</button>
                )}
              </div>

              <div className="cat-form-fields">
                <div className="rf-row">
                  <div className="rf-field">
                    <label className="rf-label">Name <span className="rf-required">*</span></label>
                    <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required className="rf-input" placeholder="e.g. AI Tools, SEO, Analytics..." />
                  </div>
                  <div className="rf-field" style={{ maxWidth: 120 }}>
                    <label className="rf-label">Order</label>
                    <input type="number" value={form.sort_order} onChange={e => setForm({ ...form, sort_order: parseInt(e.target.value) || 0 })} className="rf-input" />
                  </div>
                </div>
                <div className="rf-field">
                  <label className="rf-label">Parent Category</label>
                  <select value={form.parent_id} onChange={e => setForm({ ...form, parent_id: e.target.value ? parseInt(e.target.value) : '' })} className="rf-input">
                    <option value="">None (Top-level)</option>
                    {parentOptions.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                <div className="rf-field">
                  <label className="rf-label">Description</label>
                  <input type="text" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} className="rf-input" placeholder="Brief description of this category..." />
                </div>
              </div>
            </div>

            <div className="rf-actions" style={{ marginTop: 20, paddingTop: 20 }}>
              <button type="button" onClick={resetForm} className="rf-btn rf-btn-cancel">Cancel</button>
              <button type="submit" className="rf-btn rf-btn-save" disabled={loading}>
                {loading ? 'Saving...' : <><FaSave /> {editingId ? 'Update' : 'Create'}</>}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Toolbar: Search + Expand/Collapse */}
      <div className="cat-toolbar">
        <div className="cat-search-bar">
          <FaSearch className="cat-search-icon" />
          <input type="text" placeholder="Search categories..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
        </div>
        {hasChildren && (
          <div className="cat-toolbar-actions">
            <button className="cat-toolbar-btn" onClick={expandAll}><FaFolderOpen /> Expand All</button>
            <button className="cat-toolbar-btn" onClick={collapseAll}><FaFolder /> Collapse All</button>
          </div>
        )}
      </div>

      {/* Category Tree */}
      <div className="cat-tree">
        {parents.map(parent => {
          const PIcon = parent.icon ? getIconByName(parent.icon) : FaThLarge;
          const kids = childrenMap[parent.id] || [];
          const isExpanded = expanded.has(parent.id);
          const totalCount = (parent.resource_count || 0) + kids.reduce((s, k) => s + (k.resource_count || 0), 0);

          return (
            <div key={parent.id} className="cat-tree-group">
              {/* Parent row */}
              <div className={`cat-tree-row cat-tree-parent ${editingId === parent.id ? 'cat-tree-editing' : ''}`}>
                <button
                  className={`cat-tree-toggle ${kids.length === 0 ? 'cat-tree-toggle-empty' : ''}`}
                  onClick={() => kids.length > 0 && toggleExpand(parent.id)}
                >
                  {kids.length > 0 ? (isExpanded ? <FaChevronDown /> : <FaChevronRight />) : <span className="cat-tree-dot" />}
                </button>
                <div className="cat-tree-icon"><PIcon /></div>
                <div className="cat-tree-info">
                  <span className="cat-tree-name">{parent.name}</span>
                  <span className="cat-tree-slug">{parent.slug}</span>
                </div>
                {kids.length > 0 && (
                  <span className="cat-tree-sub-count">{kids.length} sub</span>
                )}
                <span className="cat-tree-count">{totalCount}</span>
                <span className="cat-tree-order">#{parent.sort_order}</span>
                <div className="cat-tree-actions">
                  <button onClick={() => { setShowForm(true); setEditingId(null); setForm({ name: '', icon: '', description: '', sort_order: 0, parent_id: parent.id }); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="cat-tree-btn cat-tree-btn-add" title="Add subcategory">
                    <FaPlus />
                  </button>
                  <button onClick={() => handleEdit(parent)} className="cat-tree-btn cat-tree-btn-edit" title="Edit"><FaEdit /></button>
                  <button onClick={() => handleDelete(parent.id)} className="cat-tree-btn cat-tree-btn-delete" title="Delete"><FaTrash /></button>
                </div>
              </div>

              {/* Children rows */}
              {isExpanded && kids.length > 0 && (
                <div className="cat-tree-children">
                  {kids.map(child => {
                    const CIcon = child.icon ? getIconByName(child.icon) : FaThLarge;
                    return (
                      <div key={child.id} className={`cat-tree-row cat-tree-child ${editingId === child.id ? 'cat-tree-editing' : ''}`}>
                        <div className="cat-tree-indent">
                          <span className="cat-tree-branch" />
                        </div>
                        <div className="cat-tree-icon cat-tree-icon-sm"><CIcon /></div>
                        <div className="cat-tree-info">
                          <span className="cat-tree-name">{child.name}</span>
                          <span className="cat-tree-slug">{child.slug}</span>
                        </div>
                        <span className="cat-tree-count">{child.resource_count || 0}</span>
                        <span className="cat-tree-order">#{child.sort_order}</span>
                        <div className="cat-tree-actions">
                          <button onClick={() => handleEdit(child)} className="cat-tree-btn cat-tree-btn-edit" title="Edit"><FaEdit /></button>
                          <button onClick={() => handleDelete(child.id)} className="cat-tree-btn cat-tree-btn-delete" title="Delete"><FaTrash /></button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {filteredCategories.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text-muted)' }}>
          {searchQuery ? `No categories match "${searchQuery}"` : 'No categories yet. Add one above!'}
        </div>
      )}

      {showIconPicker && (
        <IconPicker value={form.icon} onChange={(iconName) => setForm({ ...form, icon: iconName })} onClose={() => setShowIconPicker(false)} />
      )}
    </AdminLayout>
  );
}

export default Categories;
